import React from 'react';
import CommonAmount from 'src/constrains/AdvancedFilters/Components/CommonAmount';

const TotalOrderAmount = (props) => {
  const {
    noStyle,
    nameType,
    nameValue,
    nameRange,
    rules,
    suffix,
    precision,
    disabled,
  } = props;
  return (
    <CommonAmount
      noStyle={noStyle}
      nameType={nameType}
      nameValue={nameValue}
      nameRange={nameRange}
      rules={rules}
      suffix={suffix}
      precision={precision || 2}
      disabled={disabled}
    />
  );
};
export default TotalOrderAmount;
